export default {
  darkMode: 'rgb(36, 39, 41)',
  btnColor: '#47C072',
};
